<section
	class="c-login"
	[class.active]="activeLogin && isMobile$ | async"
	[class.c-login__centralize]="!justSignedUp"
	[class.rounded]="!justSignedUp"
>
	<div class="c-login__form" [class.in-down]="activeLogin && isMobile$ | async">
		<ng-container *ngTemplateOutlet="logoDefault"></ng-container>

		<form
			[formGroup]="form"
			(ngSubmit)="login()"
			class="c-form zk-space-y-4 xl:zk-mr-24"
		>
			<zk-input [zkStatus]="'default'">
				<input
					id="email"
					zkInputRef
					zkStatus="default"
					formControlName="email"
					placeholder="{{ 'PAGES.LOGIN.EMAIL' | translate }}"
					type="email"
				/>
				<span zkInputLabel>{{ 'PAGES.LOGIN.EMAIL' | translate }}</span>
			</zk-input>
			<span validation-message [control]="form.controls.email"></span>

			<zk-input [zkStatus]="'default'">
				<input
					zkInputRef
					formControlName="password"
					placeholder="{{ 'PAGES.LOGIN.PASSWORD' | translate }}"
					type="password"
				/>
				<span zkInputLabel>{{ 'PAGES.LOGIN.PASSWORD' | translate }}</span>
			</zk-input>

			<span validation-message [control]="form.controls.password"></span>
			<span class="c-validation-message__error">{{ error }}</span>

			<div class="c-form__actions">
				<span
					class="c-form__actions--forgot-password"
					(click)="onForgotPassword()"
					>{{ 'PAGES.LOGIN.FORGOT_PASSWORD' | translate }}</span
				>
				<button
					zk-button
					class="zk-pt-3"
					type="submit"
					[zkButtonColor]="buttonColorType.PRIMARY"
					[zkButtonSize]="buttonSizeType.MEDIUM"
					[zkButtonLoading]="loading"
					[disabled]="!!form.invalid"
				>
					{{ 'PAGES.LOGIN.LOGIN' | translate }}
				</button>

				<ng-container
					*ngIf="activeLogin && isMobile$ | async; then buttonSignUp"
				></ng-container>
			</div>
		</form>
	</div>
	<ng-container *ngIf="justSignedUp">
		<div class="c-login__information">
			<div class="c-description">
				<ng-container *ngIf="isMobile$ | async; then logoWhite"></ng-container>

				<div class="c-description__title">
					<h2 zkTypography="Subtitle2">
						{{ 'PAGES.LOGIN.ONBOARDING.TITLE' | translate }}
					</h2>
				</div>

				<div class="c-description__text">
					<img src="/assets/icons/login/icon-clock.svg" alt="Zenklub" />
					<span zkTypography="Body2">
						{{ 'PAGES.LOGIN.ONBOARDING.CLOCK_DESCRIPTION' | translate }}
					</span>
				</div>

				<div class="c-description__text">
					<img src="/assets/icons/login/icon-diamond.svg" alt="Zenklub" />
					<span zkTypography="Body2">
						{{ 'PAGES.LOGIN.ONBOARDING.DIAMOND_DESCRIPTION' | translate }}
					</span>
				</div>
				<div class="c-description__text">
					<img src="/assets/icons/login/icon-note.svg" alt="Zenklub" />
					<span zkTypography="Body2">
						{{ 'PAGES.LOGIN.ONBOARDING.NOTE_DESCRIPTION' | translate }}
						<a
							href="https://zenpublic.s3.amazonaws.com/ZenOffice/ZenKlub_Guia+Profissionais_Fase+01.pdf"
							target="_blank"
						>
							{{ 'PAGES.LOGIN.ONBOARDING.LINK' | translate }}
						</a>
					</span>
				</div>

				<ng-container
					*ngIf="isMobile$ | async; then buttonSignIn"
				></ng-container>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="!(isMobile$ | async); then footer"></ng-container>
</section>

<!-- Logo padrão (azul) -->
<ng-template #logoDefault>
	<div class="c-login__image">
		<a href="/" title="Zenklub">
			<img src="/assets/images/logo-zenoffice-default.svg" alt="Zenklub" />
		</a>
	</div>
</ng-template>

<!-- Logo branco -->
<ng-template #logoWhite>
	<div class="c-login__image">
		<a href="/" title="Zenklub">
			<img src="/assets/images/logo-zenoffice-white.svg" alt="Zenklub" />
		</a>
	</div>
</ng-template>

<!-- Botão entrar -->
<ng-template #buttonSignIn>
	<div class="c-description__actions">
		<button
			zk-button
			class="zk-pt-3"
			type="button"
			[zkButtonColor]="buttonColorType.WHITE"
			[zkButtonSize]="buttonSizeType.MEDIUM"
			(click)="onActiveLogin()"
		>
			{{ 'PAGES.LOGIN.LOGIN' | translate }}
		</button>
	</div>
</ng-template>

<!-- Botão Criar conta -->
<ng-template #buttonSignUp>
	<button
		zk-button
		class="zk-pt-3"
		type="button"
		(click)="onCreateAccount()"
		[zkButtonColor]="buttonColorType.SECONDARY"
		[zkButtonSize]="buttonSizeType.MEDIUM"
	>
		{{ 'PAGES.LOGIN.CREATE_ACCOUNT' | translate }}
	</button>
</ng-template>

<ng-template #footer>
	<div class="c-login__footer">
		<span class="c-login__footer--text">
			{{ 'PAGES.LOGIN.DONT_HAVE_AN_ACCOUNT' | translate }}
			<strong (click)="onCreateAccount()">{{
				'PAGES.LOGIN.REGISTER_HERE' | translate
			}}</strong>
		</span>
	</div>
</ng-template>
